/* eslint-disable no-nested-ternary */
import React, { lazy, useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  Row, Col, Tooltip,
} from 'antd';
import {
  Link, useNavigate, useSearchParams,
} from 'react-router-dom';
import {
  Company, CompanyProfile, CompanyStockChart, Section,
} from 'Types/CompaniesTypes';
import { usePrevious } from 'Utils/hooks/usePrevious';
import {
  useDispatch, useSelector,
} from 'react-redux';
import { selectCompanyCompetitors, selectCompanyExecutives, selectEntitiesLoading } from 'Selector/TopEntitiesSelector';
import { Executive } from 'Types/PersonTypes';
import {
  selectChartLoading, selectCompanyStockCharts,
  selectProfileDownloadPdfLoading,
  selectProfileDownloadPptLoading, selectCompanyDetailFlurry,
  selectCompanyDetailsCall, selectAccountPlanAllowed,
} from 'Selector/CompaniesSelector';

import {
  parseColorGradientMixture,
  backgroundColorParsing, IsMobile, IsTablet,
  valueToObject,
} from 'Utils/UtilityFunctions';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import ShareIcon from 'Components/common/assets/svgIcons/ShareIcon';
import ProfileSharePopup from 'Components/common/components/ProfileSharePopup';
import { BranchIORequest } from 'Types/RequestBodies';
import { actions as ProfileActions } from 'Slice/ProfileShareSlice';
import { actions as GroupSliceActions } from 'Slice/GroupsSlice';
import { selectCreatingLoader, selectShowMergePopup } from 'Selector/GroupsSelector';
import { CompetitorsAndExecutivesSkeleton } from 'Components/common/skeleton/CompanyCardSkeleton';
import classNames from 'classnames';
import PeopleWidgetWithOutHolo from 'Components/common/components/PeopleWidgetWithOutHolo';
import {
  primaryColor, primaryFont, primaryHeadingColor, secondaryFont, wMedium,
  wLight, wELight, maxWidth, retina, minWidthApp, maxWidth1300, maxTablet,
  maxMobile, smMobile, SecondaryColor, maxWidth1170,
} from 'Utils/utilsStyle';
import { actions } from 'Slice/CompaniesSlice';
import GroupNameMergePopup from 'Components/common/modal/GroupNameMergePopup';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import {
  selectActivetype, selectData, selectHighlight, selectIsHighlighted, selectIsScroll,
} from 'Selector/CertificationSelector';
import CompanyCompareIcon from 'Components/common/assets/svgIcons/CompanyCompareIcon';
import { actions as flurryActions } from 'Slice/HelperSlice';
import LayoutIcon from 'Components/common/assets/svgIcons/LayoutIcon';
import DrawerSmartAccount from 'Components/company/components/DrawerSmartAccount';
import {
  COMPANY_COMPETITORS_ROUTE, COMPANY_FINANCIALS_ROUTE, COMPANY_STAFF_ROUTE, COMPARE_COMPANY_ROUTE,
} from 'Utils/Constants';
import { selectDisclessPersonality } from 'Selector/GlobalSearchContentSelector';
import GlobalButton from '../../common/components/GlobalButton';
import StatesWidgetPrimary from '../../common/components/StatesWidgetPrimary';
import StockChart from '../../common/components/StockChart';
import DownloadProfile from './DownloadProfile';
import DrawerCompanyDetails from './DrawerCompanyDetails';
import TwitterIcon from '../../common/assets/svgIcons/TwitterIcon';
import LinkedInIcon from '../../common/assets/svgIcons/LinkedInIcon';
import { actions as companiesActions } from '../../../Slice/CompaniesSlice';
import BranchIo from 'deeplinking/BranchIo';


type PropFeildState = {
  linkedinLink?: string,
  twitterLink?: string,
  companyDescription?: string,
  websiteLink?: string,
  companyFinancialInfoSections?: Section[],
  companyStatus: string,
};

type Props = {
  companyProfile?: CompanyProfile
  showSAPHierarchy?: boolean
  userCompanyId?: number
} & typeof defaultProps;

const defaultProps = {
  companyProfile: { companyId: 0 },
  showSAPHierarchy: false,
  userCompanyId: 0,
};

const Wrapper = styled.div`
 padding:0 45px;
 display: flex;
 flex-direction: column;
 height: 100%;
 justify-content: space-between;
 @media all and (max-width: ${maxWidth}) , ${retina} {
   padding:0 25px;
  }
  @media all and (max-width: ${maxMobile}) {
    padding: 0 16px;
  }
  .company-details-btns-slider {
    padding-bottom: 35px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      padding-bottom: 14px;
    }
  }
.header-element {
  padding-top: 50px;
  align-items: flex-start;
  padding-top: 33px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    padding-top: 24px;
  }
  
  @media all and (max-width: ${smMobile}) {
   padding-top: 24px;
  }
  
  .left-side-action-area {
    display: flex;
    align-items: flex-start;
    .chatbot-v2-global-btn {}
    .triggers-bullet-tooltip{
      .ant-tooltip{
        z-index: 1;
        @media (max-width: ${maxTablet}) {
          display: none;
        }
      }  
    }
    .smart-plan-btn {
      svg {
        width: 20px;
        min-width: 20px;
        height: 25px;
        margin-right: 8px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          height: 17px;
        }
      }
    }
    .btn-chatGpt-drawer {
      margin-right: 12px;
      height: 43px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
       height: 30px; 
      }
    }
    .buyer-group-blue, .compare-companies-blue {
      &:hover {
        background-color: ${SecondaryColor};
        color: #fff;
        outline: none;
        svg {
          path {
            fill: #fff;
          }
        }
      }
    }
    .compare-companies-blue {
      @media all and (max-width:${minWidthApp}){
        padding: 4px 6px 4px;
      }
      svg {
        margin-right: 8px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          margin-right: 4px;
        }
      }
    }
  }
}
 h3{
  color: ${primaryHeadingColor};
  font-weight: ${wMedium};
  font-family:${primaryFont};
  font-size:20px;
  margin:0;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    font-size: 16px; 
  }
 }
 h4{
  color: ${primaryHeadingColor};
  font-weight:${wMedium};
  font-family:${primaryFont};
  font-size:14px;
  margin:0;
   span{
    font-size: 10px;
    font-weight:${wELight} ;
    font-family:${primaryFont};
  }
 }
  .finincal-detail{
    color: ${primaryColor};
    font-weight:${wMedium};
    font-family:${secondaryFont};
    font-size:14px;
    padding:4px 0;
    @media all and (max-width: ${minWidthApp}){
      font-size: 12px;
    }
    &.sm-link {
      display: inline-block;
      margin: 20px 0 10px 0;
    }
  }
 .company-description{
   margin-bottom: 15px;
    .para-text {
      margin-top: 20px;
      @media all and (max-width: ${maxMobile}){
        margin-top: 60px;
      }
    }
    &.privateCompany {
      margin-top: 0px;
      .para-text {
        margin-top: 0px;
      }
    }
   div.ant-typography, .ant-typography p{
    margin:0px;
    color:#7E7E7E;
    font-weight:${wLight};
    font-family:${primaryFont};
    font-size:16px;
    white-space: pre-wrap;
     .ant-typography-expand{
        color:${primaryColor};
      }
   }
 }
 .people-overlap-wrapper{
   position:relative;
   margin:10px 0px 0px 0px;
   z-index:0 ;
   > div{
     position: absolute;
     top:0;
     left:0;

      &:nth-child(1){
        z-index: 5;
        position: relative; ;
      }
      &:nth-child(2){
       left:60px;
       z-index:4;
       @media all and (max-width: ${maxWidth}) , ${retina} {
        left: 45px;   
       }
      }
      &:nth-child(3){
       left:120px;
       z-index:3;
       @media all and (max-width: ${maxWidth}) , ${retina} {
        left: 90px;
       }
      }
      &:nth-child(4){
       left:180px;
       z-index:2;
        @media all and (max-width: ${maxWidth}) , ${retina} {
        left: 135px;
        }
      }
      &:nth-child(5){
       left:240px;
       z-index:1;
        @media all and (max-width: ${maxWidth}) , ${retina} {
         left: 180px;
        }
        @media all and (max-width: ${maxTablet}) {
         display: none;
        }
      }
   }
 }
 .financia-row{
   margin-top: 20px;
   margin-bottom:16px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      margin-top: 0px;
      margin-bottom: 8px;
    }
 }
 .financial-card{
    margin-bottom: 16px;
  }
 .social-icon{
  display: inline-block;
  svg{
    vertical-align: text-top;
  }
 }
 .person-designation {
   font-weight: ${wLight};
   font-size: 14px !important;
 }
 .profile-right{
    padding: 0 45px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
     padding:0 25px;
    }
    @media all and (max-width: ${maxMobile}) {
     padding: 0 16px;
    }
    .button-box{
      width:100%;
      height:45px;
      margin-bottom:30px;
      border-radius:8px;
    }
    .title-small-box{
      height:20px;
      width:50%;
    }
    .number-box{
      width:100%;
      height:100px;
      border-radius:7px;
    }
    .description-box{
      width:100%;
      height:100px;
      border-radius:7px;
      margin-top: 26px;
      margin-bottom: 34px;
    }
    .graph-box{
      width:100%;
      border-radius:7px;
      margin-bottom: 0;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 175px;
      }
    }
    .users-row{
      .people-overlap-wrapper{
        position: relative;
        margin: 10px 0;
        z-index: 0;
        .user-box{
          width:70px;
          height:70px;
          border-radius:50%;
          + .user-box{
            margin-left:-16px;
          }
          @media all and (max-width: ${maxWidth1300}){
            width: 50px;
            height: 50px;
          }
        }
      }
    }
  }
  .skeleton-box {
    height: 20px;
    border-radius: 25px;
    width: 50px;
  }
  .social-placeholders {
    display: flex;
    justify-content: end;
    @media all and (max-width: ${maxWidth1170}) {
      margin-right: 8px;
    }
    .share-blue {
      margin-right: 0px;
      @media all and (max-width: ${maxMobile}) {
        margin-right: 12px;
      }
    }
    .download-profile-blue, .share-blue {
      .regenerate-icon-svg {
        width: 16px;
        height: 17px;
        margin-bottom: 2px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          width: 14px;
          height: 13px;
          margin-bottom: 3px;
        }
      } 
       svg {
        margin-right: 8px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          margin-right: 4px;
          width: 16px;
          min-width: 16px;
          height: 16px;
        }
      }
      &:hover {
        background-color: ${SecondaryColor};
        color: #fff;
        outline: none;
        svg {
          path {
            fill: #fff;
          }
        }
      }
    }
    .social-icons-wrap {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      .scc-place {
       margin-right: 0px;
       height: unset;
        &.twit-icon {
          margin-right: 8px;
        }
      }
    }
  }
  .all-competitors-here {
    @media all and (max-width: ${maxMobile}){
      margin-top: 25px;
    }
  }
`;

const BreakLineParagraph = styled.p`
  font-family: ${primaryFont};
  font-weight: ${wMedium};
  font-size: 16px;
  letter-spacing: -0.42px;
  line-height: 25px;
  color: #67696A;
  margin-bottom: 0px;
  max-height: 75px;
  overflow: hidden;
  text-align: left;
  padding-right: 0px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    font-size: 14px;
  }
`;

const ContentWrap = styled.div`
  position: relative;
  display: flex;
  align-items: end;
`;

const CompanyDetails = function CompanyDetails(props: Props) {
  const { companyProfile, showSAPHierarchy, userCompanyId } = props;
  const { companyFinancialInfo } = companyProfile;
  const [runFunction, setRunFunction] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const companyIdParsed = companyId ? parseInt(companyId, 10) : 0;
  const isTab = IsTablet();
  const isMob = IsMobile();
  const executives: Executive[] | undefined = useSelector(selectCompanyExecutives);
  const entitiesLoading: boolean = useSelector(selectEntitiesLoading);
  const companies: Company[] | undefined = useSelector(selectCompanyCompetitors);
  const stocksDataLoading: boolean = useSelector(selectChartLoading);
  const stocksData: CompanyStockChart | null = useSelector(selectCompanyStockCharts);
  const isLoadingPdf: boolean = useSelector(selectProfileDownloadPdfLoading);
  const isLoadingPpt: boolean = useSelector(selectProfileDownloadPptLoading);
  const chartsData = stocksData?.chartsData;
  const showPopup = useSelector(selectShowMergePopup);
  const accountPlanAllowed = useSelector(selectAccountPlanAllowed);
  const disclessPersonality = useSelector(selectDisclessPersonality);

  const groupCreationLoading: boolean = useSelector(selectCreatingLoader);
  const [fields, setFields] = useState<PropFeildState>({
    linkedinLink: '',
    twitterLink: '',
    companyDescription: '',
    companyFinancialInfoSections: [],
    companyStatus: 'public',
  });

  const flurryObject = useSelector(selectCompanyDetailFlurry);
  const isCalled = useSelector(selectCompanyDetailsCall);

  const previousCompany = usePrevious(companyProfile);

  useEffect(() => {
    if (companyProfile.accountPlan?.status === 'Generated') {
      const data = {
        companyId: companyProfile?.companyId,
        url: companyProfile.accountPlan?.fileUrl,
        previewUrl: companyProfile.accountPlan?.viewableUrl,
      };
      dispatch(actions.setAccountPlan(data));
      dispatch(actions.removeAccountPlanId(companyProfile?.companyId));
    }
  }, []);
  useEffect(() => {
    if (
      companyProfile?.companyId !== previousCompany?.companyId
    ) {
      const fieldsCopy = { ...fields };
      const {
        linkedinLink: linkedinLinkFromProfile,
        twitterLink: twitterLinkFromProfile,
        description,
      } = companyProfile;
      fieldsCopy.linkedinLink = linkedinLinkFromProfile;
      fieldsCopy.twitterLink = twitterLinkFromProfile;
      fieldsCopy.companyDescription = description;
      fieldsCopy.companyFinancialInfoSections = companyFinancialInfo?.sections;
      fieldsCopy.companyStatus = companyFinancialInfo?.status.toLowerCase();
      setFields(fieldsCopy);
    }
  }, [companyProfile]);

  const {
    linkedinLink,
    twitterLink,
  } = fields;

  const companyStatus = companyFinancialInfo?.status.toLowerCase();

  const data = useSelector(selectData);

  const getFinancialHighlights = (rowNumber = 0) => {
    const rows = [
      [
        {
          name: 'revenue',
          spanValue: 8,
          color: '#BE0000',
        },
        {
          name: 'sharePrice',
          spanValue: 8,
          color: '#1EC252',
        },
        {
          name: 'marketCap',
          spanValue: 8,
          color: '#BE0000',
        }],
      [
        {
          name: 'operatingMargin',
          spanValue: 12,
          color: '#BE0000',
        },
        {
          name: 'employees',
          spanValue: 12,
          color: '#1EC252',
        }],
      [
        {
          name: 'revenue',
          spanValue: 8,
          color: '#BE0000',
        },
        {
          name: 'employees',
          spanValue: 8,
          color: '#1EC252',
        }],
    ];
    const highlightCols = [];
    let index = 0;
    for (let i = 0; i < rows[rowNumber].length; i += 1) {
      index = companyFinancialInfo?.sections ? companyFinancialInfo?.sections.findIndex(
        (section) => section.name === rows[rowNumber][i].name,
      ) : -1;
      highlightCols.push(
        (
          <Col span={rows[rowNumber][i].spanValue}>
            <StatesWidgetPrimary
              state={
                companyFinancialInfo?.sections
                  && index !== -1
                  && companyFinancialInfo?.sections[index]?.value
                  ? companyFinancialInfo?.sections[index].value : 'N/A'
              }
              companyName={companyFinancialInfo?.sections
                && index !== -1
                && companyFinancialInfo?.sections[index]?.title
                ? companyFinancialInfo?.sections[index].title : 'N/A'}
              sizeText="24px"
              currency={(companyFinancialInfo?.sections
                && index !== -1
                && companyFinancialInfo?.sections[index]?.currencyCode) || ''}
              currencySymbol={(companyFinancialInfo?.sections
                && index !== -1
                && companyFinancialInfo?.sections[index]?.currencySymbol) || ''}
              colorText={primaryHeadingColor}
            />
          </Col>
        ),
      );
    }
    return highlightCols;
  };

  const onShareProfile = () => {
    if (runFunction) {
      // <BranchIo />
      const branchprofileData: BranchIORequest = {
        data: {
          $og_title: companyProfile.companyName,
          $og_description: companyProfile.description,
          $canonical_identifier: companyProfile.companyId,
          $canonical_url: window.location.href,
          title: companyProfile.companyName,
          id: companyProfile.companyId,
          entity: 'company_share',
        },
      };
      dispatch(ProfileActions.getProfileShare(branchprofileData));
    }
    setRunFunction(false);
    dispatch(certificationActions.certificationAction({
      type: 'company_share_header',
      source: 'company',
      data,
    }));
  };

  const createGroup = () => {
    dispatch(GroupSliceActions.creatingGroup({
      groupName: companyProfile.companyName,
      companyId: companyProfile.companyId,
    }));
  };

  const scrollTabInView = () => {
    const id = 'tabs-details';
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -100;
      const yScroll = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: yScroll, behavior: 'smooth' });
    }
  };

  const handlePopupCancel = () => {
    dispatch(GroupSliceActions.setShowMergePopup(false));
  };

  const handleMerge = () => {
    dispatch(GroupSliceActions.creatingGroup({
      groupName: companyProfile.companyName,
      companyId: companyProfile.companyId,
      action: 'merge',
    }));
    dispatch(GroupSliceActions.setShowMergePopup(false));
  };

  const handleSave = () => {
    dispatch(GroupSliceActions.creatingGroup({
      groupName: companyProfile.companyName,
      companyId: companyProfile.companyId,
      action: 'copy',
    }));
    dispatch(GroupSliceActions.setShowMergePopup(false));
  };

  useEffect(() => {
    if (executives?.length && !entitiesLoading) {
      dispatch(certificationActions.certificationAction({
        type: 'company_profile',
        source: 'buyer',
        data,
      }));
    }
  }, [executives]);

  const isScroll = useSelector(selectIsScroll);
  const isHighlight = useSelector(selectHighlight);
  const currentType = useSelector(selectActivetype);
  const isHighlighted = useSelector(selectIsHighlighted);

  useEffect(() => {
    if (!isHighlighted && !isScroll && (currentType === 'company_share_header' || currentType === 'company_profile' || currentType === 'company_profile_sap' || currentType === 'sap_open')) {
      dispatch(certificationActions.setHighlight(true));
      dispatch(certificationActions.setIsHighlighted(false));
    }
  }, [isScroll, currentType]);

  return (
    <Wrapper>
      <div className="d-flex justify-content-between header-element wrap-slider overFlowOnMaxWidth company-details-btns-slider">
        <GroupNameMergePopup
          visibleFlag={showPopup}
          onCancel={handlePopupCancel}
          onMerge={handleMerge}
          onSave={handleSave}
          groupName={companyProfile.companyName}
        />
        <div className="left-side-action-area">
          {accountPlanAllowed
            ? <DrawerSmartAccount companyName={companyProfile.companyName} showSAPHierarchy={showSAPHierarchy} userCompanyId={userCompanyId} /> : null}
          {
            executives?.length && !entitiesLoading && !disclessPersonality ? (
              <Tooltip
                arrow={false}
                placement="bottom"
                getPopupContainer={(e: HTMLElement) => e}
                className="triggers-bullet-tooltip no-wrap"
                color="#fff"
                title="Create Buyer Relationship Management"
              >
                <span>
                  <GlobalButton
                    title="Create BRM"
                    sup
                    textColor={SecondaryColor}
                    outlineColor={SecondaryColor}
                    RightSpace="12px"
                    PaddingSm="5px 10px"
                    innerSpace="8px 16px"
                    heightSm="30px"
                    IconLeft={isTab ? <span /> : <LayoutIcon color={SecondaryColor} height="18px" />}
                    onButtonClick={() => {
                      createGroup();
                      dispatch(certificationActions.certificationAction({
                        type: 'company_buyer',
                        source: 'buyer',
                        data,
                      }));
                    }}
                    disabled={groupCreationLoading}
                    loading={groupCreationLoading}
                    buttonClassName={classNames(
                      'buyer-group-blue',
                      { separatedSpace: groupCreationLoading },
                      { highlightedComponent: isHighlight && currentType === 'company_profile' },
                    )}
                  />
                </span>
              </Tooltip>
            ) : null
          }
          <Tooltip
            placement="bottom"
            getPopupContainer={(e: HTMLElement) => e}
            className="triggers-bullet-tooltip"
            color="#fff"
            title="Compare Companies"
            arrow={false}
          >
            <span>
              <GlobalButton
                title="Compare"
                textColor={SecondaryColor}
                outlineColor={SecondaryColor}
                RightSpace="12px"
                PaddingSm="5px 10px"
                innerSpace="8px 16px"
                heightSm="30px"
                IconLeft={isTab ? <span /> : <CompanyCompareIcon color={SecondaryColor} height="16px" width="18px" className="company-compare-svg" />}
                onButtonClick={() => {
                  dispatch(flurryActions.callFlurryEvent(
                    valueToObject('compare_company_dashboard', 0, {
                      ...flurryObject,
                      ...isCalled && { isCalled },
                    }),
                  ));
                  dispatch(companiesActions.selectedCompareCompaniesIds(companyProfile?.companyId));
                  navigate(`${COMPARE_COMPANY_ROUTE}?companyId=${companyProfile?.companyId}`);
                }}
                buttonClassName="compare-companies-blue"
              />
            </span>
          </Tooltip>
        </div>
        <div className="social-placeholders">
          {
            companyProfile?.companyPdfFlag && companyProfile?.dossierAllowed
              ? (
                <DownloadProfile
                  loading={isLoadingPdf || isLoadingPpt}
                  highlighted={false}
                  companyType={companyFinancialInfo.status}
                />
              )

              : null
          }
          <ProfileSharePopup subject={companyProfile.companyName} isPerson={false}>
            <GlobalButton
              title="Share"
              textColor={SecondaryColor}
              outlineColor={SecondaryColor}
              RightSpace="12px"
              PaddingSm="5px 10px"
              innerSpace="8px 16px"
              heightSm="30px"
              IconLeft={isTab ? <span /> : <ShareIcon color={SecondaryColor} />}
              onButtonClick={onShareProfile}
              buttonClassName={classNames(
                'share-blue',
                { highlightedComponent: isHighlight && currentType === 'company_share_header' },
                { downloadProfileBtn: isHighlight && currentType === 'company_share_header' },
              )}
            />
          </ProfileSharePopup>
          {isMob ? (
            <div className="social-icons-wrap">
              {
                linkedinLink?.length ? (
                  <a key={linkedinLink} href={linkedinLink} target="_blank" className="scc-place" rel="noreferrer">
                    <LinkedInIcon />
                  </a>
                ) : null
              }
              {
                twitterLink?.length ? (
                  <a key={twitterLink} href={twitterLink} target="_blank" className="scc-place twit-icon" rel="noreferrer">
                    <TwitterIcon />
                  </a>
                ) : null
              }
            </div>
          ) : null}
        </div>
      </div>
      <div className="body-part">
        {
          companyStatus === 'public' ? (
            <>
              <div className="d-flex justify-content-between financia-row">
                {
                  companyProfile?.companyName?.length
                    ? <h3>{`Financial highlights for ${companyProfile?.companyName}`}</h3>
                    : null
                }
                {!isMob ? (
                  <Link
                    to={`${COMPANY_FINANCIALS_ROUTE}${companyIdParsed}`}
                    className="finincal-detail"
                    onClick={() => {
                      dispatch(flurryActions.callFlurryEvent(
                        valueToObject('company_financials_clicked', 0, {
                          ...flurryObject,
                          ...isCalled && { isCalled },
                        }),
                      ));
                      scrollTabInView();
                    }}
                    replace
                  >
                    Financial details
                  </Link>
                ) : null}
              </div>
              <Row gutter={14} className="company-states-row">
                <Col span={12} xs={24} sm={24} md={12} className="h-auto">
                  <Row gutter={16}>
                    {
                      getFinancialHighlights(0)
                    }
                  </Row>
                  <Row gutter={16}>
                    {
                      getFinancialHighlights(1)
                    }
                  </Row>
                </Col>
                <Col span={12} xs={24} sm={24} md={12}>
                  {isMob ? (
                    <Link
                      to={`${COMPANY_FINANCIALS_ROUTE}${companyIdParsed}`}
                      className="finincal-detail sm-link"
                      onClick={() => scrollTabInView()}
                    >
                      Financial details
                    </Link>
                  ) : null}
                  {
                    !stocksDataLoading ? stocksData?.status.toLowerCase() !== 'private' && chartsData && Object.keys(chartsData).length
                      && <StockChart chartHeading="Stock Price" chartsData={chartsData} />
                      : <SkeletonCustom height="172px" width="100%" />
                  }
                </Col>
              </Row>
            </>
          ) : null
        }
        <div
          className={classNames('company-description', { privateCompany: companyStatus === 'private' })}
        >
          <ContentWrap className="para-text">
            <BreakLineParagraph>
              {companyProfile.description?.length ? companyProfile.description : 'N/A'}
            </BreakLineParagraph>
            {(companyProfile.description ?? '').length > 0
              ? (
                <DrawerCompanyDetails
                  titleOne={companyProfile.companyName}
                  desc={companyProfile.description}
                />
              )
              : null}
          </ContentWrap>
        </div>
        {
          companyStatus === 'private' ? (
            <>
              <div className="d-flex justify-content-between financia-row">
                <h3>Company highlights</h3>
              </div>
              <Row gutter={16}>
                {
                  getFinancialHighlights(2)
                }
              </Row>
            </>
          ) : null
        }
      </div>
      {
        entitiesLoading ? (
          <div className="profile-right">
            {CompetitorsAndExecutivesSkeleton()}
          </div>
        ) : (
          <Row gutter={30} className="company-card-bottom-area">
            {
              executives?.length ? (
                <Col span={12} xs={24} sm={24} md={12}>
                  <div className="d-flex justify-content-between">
                    <h3 className="text-truncate w-70">{`Executives at ${companyProfile?.companyName}`}</h3>
                    <Link
                      to={`${COMPANY_STAFF_ROUTE}${companyIdParsed}`}
                      className="finincal-detail"
                      onClick={() => {
                        dispatch(flurryActions.callFlurryEvent(
                          valueToObject('company_allStaff_clicked', 0, {
                            ...flurryObject,
                            ...isCalled && { isCalled },
                          }),
                        ));
                        scrollTabInView();
                      }}
                      replace
                    >
                      All Staff
                    </Link>
                  </div>
                  <div className="people-overlap-wrapper">
                    {
                      executives?.slice(0, 5).map((person) => (
                        <PeopleWidgetWithOutHolo
                          key={person?.personId}
                          diameter="76px"
                          diameterSm="54px"
                          diameterXsm="50px"
                          wrapperColor={backgroundColorParsing(person.personalityTypes)}
                          logo={person.personImage}
                          personId={person?.personId}
                          showPersonName
                          personName={person.personName}
                          personDesignation={person.personDesignation}
                          personForHover
                          topPersonHover
                          ringPadding="3px"
                          ringPaddingSm="3px"
                        />
                      ))
                    }
                  </div>
                </Col>
              ) : null
            }
            {
              companies?.length ? (
                <Col span={12} xs={24} sm={24} md={12}>
                  <div className="d-flex justify-content-between all-competitors-here">
                    <h3>Competitors</h3>
                    <Link
                      to={`${COMPANY_COMPETITORS_ROUTE}${companyIdParsed}`}
                      className="finincal-detail"
                      onClick={() => scrollTabInView()}
                      replace
                    >
                      All Competitors
                    </Link>
                  </div>
                  <div className="people-overlap-wrapper">
                    {
                      companies?.slice(0, 5).map((company) => (
                        <PeopleWidgetWithOutHolo
                          key={company?.companyId}
                          diameter="76px"
                          diameterSm="54px"
                          diameterXsm="50px"
                          wrapperColor={parseColorGradientMixture(company.companyPersonality)}
                          logo={company.companyLogo}
                          companyId={String(company.companyId) !== '' ? company.companyId : 0}
                          showPersonName
                          personName={company.companyName}
                          personForHover
                          topPersonHover
                          ringPadding="3px"
                          ringPaddingSm="3px"
                        />
                      ))
                    }
                  </div>
                </Col>
              ) : null
            }
          </Row>
        )
      }
    </Wrapper>
  );
};

CompanyDetails.defaultProps = defaultProps;
export default CompanyDetails;
